var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeSection3Icon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0615 0.968262H6.03924C3.20113 0.968262 0.900391 3.269 0.900391 6.10711V22.1658C0.900391 25.0039 3.20113 27.3047 6.03924 27.3047H23.0615C25.8996 27.3047 28.2004 25.0039 28.2004 22.1658V6.10711C28.2004 3.269 25.8996 0.968262 23.0615 0.968262Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9322 2.50256H6.17091C4.7519 2.50256 3.60156 3.6529 3.60156 5.07191V23.2414C3.60156 24.6604 4.7519 25.8108 6.17091 25.8108H22.9322C24.3512 25.8108 25.5016 24.6604 25.5016 23.2414V5.07191C25.5016 3.6529 24.3512 2.50256 22.9322 2.50256Z",
    fill: "#D2FA52"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.798 15.4127L12.2288 24.6168L10.7508 20.4597L6.76562 22.3559L10.7508 13.3236L15.798 15.4127Z",
    fill: "#005D1F",
    stroke: "#003512",
    strokeWidth: 0.13935,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2852 15.4127L16.8522 24.6168L18.3324 20.4597L22.3152 22.3559L18.3324 13.3236L13.2852 15.4127Z",
    fill: "#005D1F",
    stroke: "#003512",
    strokeWidth: 0.13935,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.541 17.6805C18.3693 17.6805 21.4727 14.577 21.4727 10.7488C21.4727 6.92055 18.3693 3.8172 14.541 3.8172C10.7129 3.8172 7.60938 6.9207 7.60938 10.7488C7.60938 14.577 10.7129 17.6805 14.541 17.6805Z",
    fill: "#14AA40",
    stroke: "#003512",
    strokeWidth: 0.13935,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5412 10.7489L17.5667 4.50963M14.5412 10.7489L19.3699 5.77593M14.5412 10.7489L21.136 8.60868M14.5412 10.7489L21.4496 10.1609M14.5412 10.7489L21.2197 12.6146M14.5412 10.7489L20.0903 14.9034M14.5412 10.7489L17.9944 16.7625M14.5412 10.7489L16.5164 17.3969M14.5412 10.7489L13.5722 17.6153M14.5412 10.7489L11.5412 17.0018M14.5412 10.7489L9.53586 15.5472M14.5412 10.7489L8.59026 14.3063M14.5412 10.7489L7.63281 11.3412M14.5412 10.7489L7.79316 9.14793M14.5412 10.7489L8.93646 6.66843M14.5412 10.7489L11.3228 4.60713M14.5412 10.7489L14.9851 3.83118",
    stroke: "#003512",
    strokeWidth: 0.13935,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5414 14.8293C16.795 14.8293 18.6218 13.0023 18.6218 10.7488C18.6218 8.49525 16.795 6.6684 14.5414 6.6684C12.2878 6.6684 10.4609 8.49525 10.4609 10.7488C10.4609 13.0023 12.2878 14.8293 14.5414 14.8293Z",
    fill: "white",
    stroke: "#003512",
    strokeWidth: 0.13935,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.541 7.34448L15.1917 9.17793L16.9483 8.34138L16.1118 10.0982L17.9452 10.7487L16.1118 11.3994L16.9483 13.1562L15.1917 12.3219L14.541 14.153L13.8903 12.3219L12.1336 13.1562L12.9678 11.3994L11.1367 10.7487L12.9678 10.0982L12.1336 8.34138L13.8903 9.17793L14.541 7.34448Z",
    fill: "#D2FA52",
    stroke: "#003512",
    strokeWidth: 0.13935,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeSection3Icon);
export default __webpack_public_path__ + "static/media/HomeSection3Icon.87dd48ef99e40009bd35ca7841c07a4a.svg";
export { ForwardRef as ReactComponent };